export default __webpack_public_path__ + "static/media/tut-bot.192582fc.jpg";